import * as React from "react";
import { selectPlayerProfilePictureName } from "../../balancingSelectors/selectBalancingPictures";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../utils/utilNumber";
import { FontWithOutline } from "../generic/font-with-outline/FontWithOutline";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../generic/number-format/TypeNumberFormat";
import { TextLoca } from "../generic/text/TextLoca";
import { ProfilePicture } from "../player-profile/ProfilePicture";
export var RewardStoreProfilePictures = function (_a) {
    var rewards = _a.rewards;
    var duplicatedProfilePictureRewards = rewards.duplicatedProfilePictureRewards, convertedSnippetsFromProfilePicture = rewards.convertedSnippetsFromProfilePicture;
    var snippetRewardElement;
    var rewardElements = rewards.profilePictureRewards.map(function (picture) {
        var typeId = picture.typeId;
        var amount = picture.amount;
        var profilePictureName = selectPlayerProfilePictureName(typeId);
        var isProfilePictureDuplicate = duplicatedProfilePictureRewards.findIndex(function (duplicatePicture) { return duplicatePicture.typeId === picture.typeId; });
        if (isProfilePictureDuplicate !== -1) {
            var locaReplacements = new Map([
                [
                    ReplacementLoca.zero_0,
                    utilNumber.format(convertedSnippetsFromProfilePicture[0].amount),
                ],
            ]);
            snippetRewardElement = (React.createElement("div", { className: IdStyles.ProfilePictureBalloon + " absolute flex" },
                React.createElement(TextLoca, { id: IdLoca.mysteryChestRewardDialog_pictureDuplicate, className: IdStyles.TextNormal + " w100", replacements: locaReplacements }),
                React.createElement(Icon, { icon: IdIcon.ExclamationMarkIcn, styleId: IdStyles.IconLarge })));
        }
        return (React.createElement("div", { className: "flex flex--guts flex--stacked", key: typeId },
            React.createElement(ProfilePicture, { profilePictureName: profilePictureName, profilePictureSize: IdStyles.ProfilePictureSmall }),
            React.createElement(FontWithOutline, { style: IdStyles.TextBoldSecondaryOutline },
                React.createElement(NumberFormat, { amount: amount, format: TypeNumberFormat.None }))));
    });
    return (React.createElement("div", { className: "flex flex--guts" },
        React.createElement("div", { className: "chest-rewards-background flex flex--guts" }, rewardElements),
        snippetRewardElement));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/store/RewardStoreProfilePictures.tsx
// module id = 2928
// module chunks = 3